module.exports = __webpack_public_path__ + "img/your_personality_traits.703f916a.svg";